export default __webpack_public_path__ + "static/media/search_icon.c4c77d44.svg";